import { render } from "./RDVView.vue?vue&type=template&id=5bf9ace1&scoped=true"
import script from "./RDVView.vue?vue&type=script&lang=js"
export * from "./RDVView.vue?vue&type=script&lang=js"

import "./RDVView.vue?vue&type=style&index=0&id=5bf9ace1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf9ace1"]])

export default __exports__